import { ApolloLink } from '@apollo/client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { ANONYMOUS_TOKEN } from './auth-link';

export const sha256 = async (string: string) => {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');

  return hashHex;
};

export function createAutomaticPersistedQueryLink() {
  return new ApolloLink((operation, forward) => {
    const context = operation.getContext();

    if (context.headers.Authorization === ANONYMOUS_TOKEN) {
      const persistedLink = createPersistedQueryLink({
        sha256,
        useGETForHashedQueries: true,
      });

      return persistedLink.request(operation, forward);
    }

    return forward(operation);
  });
}

export const useAPQLink = () => createAutomaticPersistedQueryLink();
